export const firebaseConfig = {
  apiKey: "AIzaSyAqzx2jAUiNtulNowocuxEhRuwROyIJvH4",
  authDomain: "mellasa.com",
  projectId: "mellasa-1f9c6",
  storageBucket: "mellasa-1f9c6.appspot.com",
  messagingSenderId: "2285326264",
  appId: "1:2285326264:web:9e4c7a9bbf02bc5c99c94d",
  measurementId: "G-QJGXXSVD48",
};
